var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerveNoBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26645 12.1331C8.26645 14.4158 6.41599 16.2663 4.1333 16.2663C1.85052 16.2663 0 14.4158 0 12.1331C0 9.85047 1.85052 8 4.1333 8C6.41599 8 8.26645 9.85047 8.26645 12.1331Z",
    fill: "#ED342B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13292 13.9036C3.20841 11.808 2.53054 9.85029 2.53054 9.85029H1.11328C1.11328 9.85029 1.97589 12.363 3.57822 15.5053H4.68762C6.28995 12.363 7.1525 9.85029 7.1525 9.85029H5.73524C5.73524 9.85029 5.05743 11.808 4.13292 13.9036Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9336 11.9176C21.1324 11.9176 21.0709 12.7804 21.0709 12.7804H22.7962C22.7962 12.7804 22.7347 11.9176 21.9336 11.9176ZM23.8439 13.643H21.0709C21.0709 13.643 21.1324 14.5674 22.365 14.5674C22.9811 14.5674 23.5974 14.3824 23.5974 14.3824L23.7207 15.3683C23.7207 15.3683 23.1045 15.6149 22.2417 15.6149C21.0093 15.6149 19.9001 14.9986 19.9001 13.2733C19.9001 11.9176 20.7628 11.0549 21.9953 11.0549C23.8439 11.0549 23.967 12.9035 23.8439 13.643ZM14.4148 12.1869L14.6056 11.1695C14.6056 11.1695 13.1323 10.7224 11.9348 11.5509V15.6207H13.2065V12.314C13.7152 11.9326 14.4148 12.1869 14.4148 12.1869ZM9.11368 11.9176C8.31265 11.9176 8.25107 12.7804 8.25107 12.7804H9.9764C9.9764 12.7804 9.91487 11.9176 9.11368 11.9176ZM11.0239 13.643H8.25107C8.25107 13.643 8.31265 14.5674 9.54507 14.5674C10.1611 14.5674 10.7774 14.3824 10.7774 14.3824L10.9007 15.3683C10.9007 15.3683 10.2845 15.6149 9.42175 15.6149C8.18933 15.6149 7.08008 14.9986 7.08008 13.2733C7.08008 11.9176 7.94285 11.0549 9.17526 11.0549C11.0239 11.0549 11.1471 12.9035 11.0239 13.643ZM17.5185 14.0653C16.8727 12.5153 16.5499 11.0556 16.5499 11.0556L15.2586 11.0558C15.2586 11.0558 15.9044 13.5486 17.0021 15.6142H18.0348C19.1326 13.5486 19.7784 11.0561 19.7784 11.0561H18.487C18.487 11.0561 18.1642 12.5153 17.5185 14.0653Z",
    fill: "#03435F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerveNoBorder);
export default __webpack_public_path__ + "static/media/verve-no-border.1d34a5f4b7c1a7098367725f8f3644e2.svg";
export { ForwardRef as ReactComponent };